import { useEffect, useRef, useState } from "react"
import iro from "@jaames/iro"
import ReactSlider from "react-slider"
import { Global } from "../classes/global"
import { Player } from "../classes/player"

interface ColourWheelPickerProps {
	onChange: (colour: string) => void
	value: string
}

function ColourWheelPicker({ onChange, value }: ColourWheelPickerProps) {
	const colourPickerRef = useRef<HTMLDivElement>(null)
	const colourPickerInstance = useRef<iro.ColorPicker | null>(null)
	const onChangeRef = useRef(onChange)

	useEffect(() => {
		onChangeRef.current = onChange
		if (colourPickerInstance.current != null) {
			colourPickerInstance.current!.on("color:change", (color) => {
				const newValue = color.hexString
				if (onChangeRef.current) {
					onChangeRef.current(newValue)
					Global.colourPickerValue = newValue
				}
			})
		}
		Global.spatialColourValueChange = (newColor: string) => {
			if (colourPickerInstance.current) {
				colourPickerInstance.current.color.set(newColor)
				// Directly invoke the onChange handler if needed to propagate changes
				onChangeRef.current?.(newColor)
			}
		}
	}, [onChange])

	useEffect(() => {
		if (colourPickerRef.current && !colourPickerInstance.current) {
			colourPickerInstance.current = new iro.ColorPicker(
				colourPickerRef.current,
				{
					width: 130,
					layout: [
						{
							component: iro.ui.Slider,
						},
						{
							component: iro.ui.Wheel,
						},
					],
					layoutDirection: "horizontal",
					color: value, // Initial color
				}
			)

			colourPickerInstance.current.on("color:change", (color) => {
				const newValue = color.hexString
				if (onChangeRef.current) {
					onChangeRef.current(newValue)
					Global.colourPickerValue = newValue
				}
			})
		}
	}, [])

	return <div ref={colourPickerRef}></div>
}

export function Hem() {
	const [sliderValue, setSliderValue] = useState(10)
	const [colourValue, setColourValue] = useState("#FFFFFF") // State to manage color valu

	// This function can be exposed to change the slider value
	function sliderChangeShine(value: number) {
		setSliderValue(value) // Call this function to change slider value externally
		Player.setShine(value)
	}

	// Exposing the function globally for demonstration; replace with your preferred way of making it accessible externally
	Global.spatialSliderValue = sliderChangeShine

	function changeColourValue(value: string) {
		setColourValue(value) // Update local state
		Global.colourPickerValue = value
		Player.setHems(value)
	}

	// Exposing the function globally for demonstration; replace with your preferred way of making it accessible externally
	Global.spatialColourValueChange = changeColourValue

	return (
		<div className="tab">
			<input type="radio" name="accordion-2" id="rd3" />
			<label htmlFor="rd3" className="tab__label">
				Hem
			</label>
			<div id="hemContainer" className="tab__content">
				<div id="colourWheel">
					<p className="hemContent">Colour</p>
					<ColourWheelPicker onChange={changeColourValue} value={colourValue} />
				</div>
				<div id="hemShine">
					<p className="hemContent">Shine </p>
					<ReactSlider
						className="vertical-slider"
						markClassName="example-mark"
						min={0}
						max={100}
						value={sliderValue}
						onChange={sliderChangeShine}
						orientation="vertical"
						thumbClassName="example-thumb"
						trackClassName="example-track"
						renderThumb={(props, state) => (
							<div {...props}>{state.valueNow}</div>
						)}
					/>
				</div>
			</div>
		</div>
	)
}
